import React from 'react';
import {
} from 'reactstrap';
import Slider from "react-slick";
import MEDIA_URL from '../../contants';

class CasinoSlider extends React.Component {

  SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "red", bottom: 0, width: "200px", height: "30px", content: "<" }}
        onClick={onClick}
      />
    );
  }

  SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none", background: "green", top: 0, width: "200px", height: "30px" }}
        onClick={onClick}
      />
    );
  }

	render() {

      const settings = {
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      speed: 2000,
      autoplaySpeed: 2000,
      cssEase: "linear",
      vertical: true,
      focusOnSelect: true,
      nextArrow: < this.SampleNextArrow />,
      prevArrow: <this.SamplePrevArrow />
    };

		return (
      <div className="login_hide">
        <Slider {...settings}>
            <img src={MEDIA_URL + '/web-images/casino-slider/baccarat.png'} alt=""/>
            <img src={MEDIA_URL + '/web-images/casino-slider/amar.png'} alt=""/>
            <img src={MEDIA_URL + '/web-images/casino-slider/bolliwoodcasino.png'} alt=""/>
            <img src={MEDIA_URL + '/web-images/casino-slider/casinowar.png'} alt=""/>
            <img src={MEDIA_URL + '/web-images/casino-slider/cricket20.png'} alt=""/>
            <img src={MEDIA_URL + '/web-images/casino-slider/icard20.png'} alt=""/>
            <img src={MEDIA_URL + '/web-images/casino-slider/rummyclub.png'} alt=""/>
        </Slider>
      </div>
		);
	}
}

export default CasinoSlider;
